<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>
            <h1>{{ 'repository.licenses.title' | translate }}</h1>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="creation-form">
            <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'repository.licenses.add' | translate"
                mat-mini-fab class="action-button" color="primary">
                <mat-icon aria-label="Add">add</mat-icon>
            </button>
            <app-license-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"
                [clients]="clients"></app-license-edit>
        </section>

        <section class="headerFilter">
            <app-displayed-columns-menu [columnsParams]="columnsParams"
                (onMooveColumnsOrderEvent)="onMooveColumnsOrder($event)"
                (onSelectColumnVisibilityEvent)="onSelectColumnVisibility($event)"></app-displayed-columns-menu>

            <form [formGroup]="filterForm" (submit)="onFilter()" class="filterForm">

                <mat-form-field>
                    <mat-label>Entrer une période</mat-label>
                    <mat-date-range-input formGroupName="range" [rangePicker]="picker">
                        <input matStartDate formControlName="startDate" placeholder="Du" (focus)="picker.open()">
                        <input matEndDate formControlName="endDate" placeholder="Au" (focus)="picker.open()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <button mat-icon-button type="submit" color="primary"
                    [disabled]="!filterForm.value.range.startDate || !filterForm.value.range.endDate"
                    matTooltip="Filtrer">
                    <mat-icon>
                        search
                    </mat-icon>
                </button>

                <button mat-icon-button color="primary" matTooltip="Effacer les filtres" (click)="clearFilters()">
                    <mat-icon>
                        clear
                    </mat-icon>
                </button>
            </form>
        </section>

        <section class="datatable-wrapper">
            <div class="datatable-container">
                <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
                    (matSortChange)="onSortChanged($event)">
                    <ng-container matColumnDef="clientName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <div class="cellTh">
                                {{ findColumnTranslationKey('clientName')| translate }}
                                <div>
                                    <app-autocomplete-filter class="autocompleteFilter" *ngIf="!isLoadingFilterForm"
                                        [valueWanted]="'name' " [control]="filterForm.get('clientName')"
                                        [list]="clients" (click)="$event.stopPropagation()"
                                        (keydown.enter)="$event.stopPropagation(); onFilter()">
                                    </app-autocomplete-filter>
                                </div>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let license">
                            {{ license.client.name }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ findColumnTranslationKey('startDate') | translate }}
                        </th>
                        <td mat-cell *matCellDef="let license">
                            {{ license.startDate | amDateFormat: 'DD/MM/YYYY' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ findColumnTranslationKey('endDate') | translate }}
                        </th>
                        <td mat-cell *matCellDef="let license">
                            {{ license.endDate | amDateFormat: 'DD/MM/YYYY' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="monthlyPrice">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ findColumnTranslationKey('monthlyPrice') | translate }}
                        </th>
                        <td mat-cell *matCellDef="let license">
                            {{ license.monthlyPrice }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pricePerExtraOrder">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ findColumnTranslationKey('pricePerExtraOrder') | translate }}
                        </th>
                        <td mat-cell *matCellDef="let license">
                            {{ license.pricePerExtraOrder }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="maxOrdersPerMonth">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ findColumnTranslationKey('maxOrdersPerMonth') | translate }}
                        </th>
                        <td mat-cell *matCellDef="let license">
                            {{ license.maxOrdersPerMonth }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="comment">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ findColumnTranslationKey('comment') | translate }}
                        </th>
                        <td mat-cell *matCellDef="let license">
                            {{ license.comment }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>
                            {{findColumnTranslationKey('actions') | translate}}
                        </th>
                        <td mat-cell *matCellDef="let license">

                            <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button color="primary" mat-icon-button (click)="onEdit(license.id)"
                                    matTooltip="Modifier">
                                    <mat-icon>edit</mat-icon>
                                </button>

                                <button color="primary" mat-icon-button (click)="onDelete(license)"
                                    matTooltip="Supprimer">
                                    <mat-icon>delete</mat-icon>
                                </button>

                                <button color="primary" mat-icon-button [routerLink]="['/documents']"
                                    [queryParams]="{ category: '7', clientName: license.client.name}"
                                    matTooltip="Voir les documents">
                                    <mat-icon>attach_file</mat-icon>
                                </button>
                            </mat-menu>

                    </ng-container>

                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let license" [attr.colspan]="displayedColumns.length">
                            <div *ngIf="license.id === editedId" class="row-edit"
                                [@detailExpand]="license.id === editedId ? 'expanded' : 'collapsed'">
                                <app-license-edit [license]="license" [clients]="clients"
                                    (editFinished)="onEditFinished()"></app-license-edit>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
                        [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
                </table>
            </div>
            <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate"
                color="primary"></mat-progress-bar>
            <mat-paginator *ngIf="pagination" [pageSize]="pagination.pageSize" [length]="pagination.totalRecords"
                [pageIndex]="pagination.pageNumber - 1" (page)="onPageChanged($event)"
                showFirstLastButtons></mat-paginator>
        </section>
    </mat-card-content>
</mat-card>